import React from "react";
import SiteManContextProvider, { SiteManContext } from "../components/SiteMan/SiteManContext";
import DataTable from "../../utils/DataTable";

const SiteManPage = () => {
  return (
    <SiteManContextProvider>
      <div className="container-fluid mt-3">
        <h2>Site Manager</h2>
        <DataTable title="Sites" itemName="Site" context={SiteManContext} pageSize={20} />
      </div>
    </SiteManContextProvider>
  );
};

export default SiteManPage;